import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type DeviceMobileIconProps = CreateIconComponentProps;
export const DeviceMobileIcon: React.FC<DeviceMobileIconProps> = ({
  title = 'DeviceMobile',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <rect
      width="10"
      height="16"
      x="7"
      y="4"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      rx="1"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M11 5h2M12 17v.01"
    />
  </CreateIconComponent>
);
